export default "__VITE_ASSET__D7ii0r4___"